import { getErrorMessage } from "@/core/services";
import { useAsyncQuery } from "@/ds";
import { listarColetoresDoTipo } from "@/modules/financeiro-configuracoes";
import type { ParteDoTipo } from "@/modules/financeiro-configuracoes";

const SEM_PARTES: ParteDoTipo[] = [];

export const COLETORES_FORBIDDEN_MESSAGE = "Você não tem permissão para consultar os coletores.";
export const COLETORES_ERROR_MESSAGE = "Não foi possível carregar os coletores do Tipo de Obra.";

export function useColetoresDoTipo(tipoObraId: string | null) {
  const consulta = useAsyncQuery<ParteDoTipo[]>({
    fetcher: (signal) => listarColetoresDoTipo(tipoObraId ?? "", { signal }),
    queryKey: `distribuicoes:coletores:${tipoObraId ?? ""}`,
    initialData: SEM_PARTES,
    enabled: tipoObraId !== null,
    forbiddenMessage: COLETORES_FORBIDDEN_MESSAGE,
    errorMessage: COLETORES_ERROR_MESSAGE,
    resolveErrorMessage: getErrorMessage,
  });

  return {
    partes: consulta.data,
    carregando: tipoObraId !== null && consulta.status === "loading",
    erro:
      consulta.status === "error" || consulta.status === "forbidden" ? consulta.errorMessage : null,
    recarregar: consulta.reload,
  };
}
